import { Mail, Phone, Globe } from "lucide-react";
import { IdentityQR } from "@/components/identity/IdentityQR";
import { PlatformIcon } from "@/features/identity/components/PlatformIcon";
import { getPlatform } from "@/features/identity/constants/platforms";
import "@/features/cards/templates/lockedCard.css";

export const CARD_LABEL = "Digital Business Card";
export const QR_CAPTION = "Scan to view my professional profile";

export const hostOf = (url) => {
  try {
    return new URL(url).host.replace(/^www\./, "");
  } catch {
    return url;
  }
};

export function ContactRows({ identity, className = "" }) {
  const rows = [
    identity.email && { key: "email", Icon: Mail, text: identity.email },
    identity.phone && { key: "phone", Icon: Phone, text: identity.phone },
    identity.website && { key: "website", Icon: Globe, text: hostOf(identity.website) },
  ].filter(Boolean);
  if (!rows.length) return null;
  return (
    <ul className={`mwc-contacts ${className}`}>
      {rows.map(({ key, Icon, text }) => (
        <li key={key}>
          <Icon aria-hidden="true" />
          <span>{text}</span>
        </li>
      ))}
    </ul>
  );
}

export function SocialLinks({ links, className = "", labels = true }) {
  if (!links.length) return null;
  return (
    <ul className={className}>
      {links.map((l) => (
        <li key={l.platform}>
          <PlatformIcon platform={l.platform} className="" />
          {labels && <span>{getPlatform(l.platform).label}</span>}
        </li>
      ))}
    </ul>
  );
}

export const Photo = ({ src, shape, className = "", alt = "" }) =>
  src ? <img src={src} alt={alt} className={`${className} mwc-shape-${shape}`} /> : null;

export const Logo = ({ src, className = "", alt = "" }) => (src ? <img src={src} alt={alt} className={className} /> : null);

export function CardQR({ value, className = "", caption = true, fg, bg, testId }) {
  return (
    <div className={`mwc-qr ${className}`}>
      <div className="mwc-qr-tile">
        <IdentityQR value={value} size={null} fg={fg} bg={bg} testId={testId} />
      </div>
      {caption && value && <p className="mwc-qr-caption">{QR_CAPTION}</p>}
    </div>
  );
}
